import React from 'react';
import { renderToString } from 'react-dom/server';

import VerticalProduct from '@Themes/natucare/modules/Article/components/VerticalProduct/VerticalProduct';
import HorizontalProduct from '@Themes/natucare/modules/Article/components/HorizontalProduct/HorizontalProduct';

const replaceAdsProductIds = (items, match, id1, id2) => {
  let html = '';
  const id = id1 || id2;
  const ad = items?.[id];

  try {
    if (!ad) return html;

    const variantName = ad?.variant?.variant || '';
    const isVerticalVariant =
      variantName === 'Vertical - Product image' ||
      variantName === 'Vertical - Lifestyle image';
    const isHorizontalVariant = variantName === 'Horizontal';
    const isHiddenAd = Array.isArray(ad?.options)
      ? ad.options.includes('Hide product')
      : false;

    const products = Array.isArray(ad?.products)
      ? ad.products
      : ad?.products
      ? [ad.products]
      : [];

    if (products.length === 0) return html;

    html = products
      .map((product) => {
        if (!product) return '';

        const productData = {
          picture: {
            src: product?.imageVertical?.url || null,
            alt: product?.heading || '',
            caption: product?.imageHorizontalCaption?.data?.imageHorizontalCaption || '',
          },
          heading: product?.heading || '',
          button: {
            label: product?.button.label || '',
            href: product?.button.url || null,
          },
          id: isHiddenAd ? 'alternative' : null,
          style: isHiddenAd ? { display: 'none' } : null,
          text: product?.description || '',
          quote: {
            text: product?.quoteText || '',
            name: product?.quoteName || '',
            image: {
              src: product?.quoteImage?.url || null,
              alt: product?.quoteName || '',
            },
          },
        };

        if (isVerticalVariant) {
          productData.picture.src =
            variantName === 'Vertical - Lifestyle image'
              ? product?.imageVerticalFull?.url || productData.picture.src
              : productData.picture.src;

          return renderToString(<VerticalProduct {...productData} />);
        }

        if (isHorizontalVariant) {
          productData.picture.src = product?.imageHorizontal?.url || productData.picture.src;
          return renderToString(<HorizontalProduct {...productData} />);
        }

        // Unknown variant -> render nothing for this product
        return '';
      })
      .join('');

    if (isVerticalVariant && products.length > 1) {
      html = `<div class="verticalProductWrapper">${html}</div>`;
    }

    return html;
  } catch (err) {
    console.log(`Error processing ad with id ${id ?? 'non-id'}:`, err);
    return '';
  }
};

export default replaceAdsProductIds;
